import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { rolesApi as r } from "@maat/api-main";
//#region src/workspaces/useDuplicateRoleMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ roleId: e, ...t }) => r.duplicateRole(e, t),
		onSuccess: (t, { roleId: n }) => {
			i.invalidateQueries({ queryKey: e.roles() }), i.invalidateQueries({ queryKey: e.role(n) });
		}
	});
};
//#endregion
export { i as useDuplicateRoleMutation };
